
  import { mapGetters } from 'vuex';

  export default {
    props: {
      count: { type: Number, required: true },
      header: { type: String, default: null },
      loading: { type: Boolean, default: false },
      mobileFilterSearchButton: { type: Boolean, default: false },
      mobileFilterButtonString: { type: String, default: null },
      prependFiltersHeader: { type: String, default: null },
      showExtraFilters: { type: Boolean, default: false }
    },
    computed: {
      ...mapGetters('providers', { provider: 'get' }),
      ...mapGetters('utils', { filterDisplay: 'getFilterDisplay', filterExtraDisplay: 'getFilterExtraDisplay' }),
      providerDisplay () {
        return this.provider;
      }
    },
    beforeDestroy () {
      this.$store.commit('utils/setFilterDisplay', false);
      this.$store.commit('utils/setFilterExtraDisplay', false);
    }
  };
